module.exports = __webpack_public_path__ + "img/full-screen-exit.96dd9b56.svg";